<script lang="ts">
  export let data;
</script>

<div class="relative mx-auto flex w-full justify-center">
  <slot />
</div>
